export enum OxfordRiskSegment {
    Advisers = 'advisers',
    DownloadOxfordRiskPdf = 'downloadoxfordriskpdf',
    Person = 'person',
    RiskAssessment = 'riskassessment',
    Snapshots = 'snapshots',
}
